'use strict';

var httpApi = require('./httpApi.js');
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var IdentityPatternType = /*#__PURE__*/function (IdentityPatternType) {
  IdentityPatternType["INHERIT"] = "inherit";
  IdentityPatternType["METHOD_AND_PATH"] = "methodAndPath";
  IdentityPatternType["OPERATION_ID"] = "operationId";
  IdentityPatternType["QUERY"] = "query";
  IdentityPatternType["BODY"] = "body";
  IdentityPatternType["HEADER"] = "header";
  return IdentityPatternType;
}({});
var IdentityPatternBodyType = /*#__PURE__*/function (IdentityPatternBodyType) {
  IdentityPatternBodyType["FormData"] = "formdata";
  IdentityPatternBodyType["XWwwFormUrlencoded"] = "urlencoded";
  return IdentityPatternBodyType;
}({});
var initIdentityPattern = {
  httpApi: {
    type: IdentityPatternType.METHOD_AND_PATH,
    bodyType: '',
    fields: []
  }
};
var IdentityPatternBodyTypeMap = _defineProperty(_defineProperty({}, IdentityPatternBodyType.FormData, httpApi.HttpApiRequestBodyType.FormData), IdentityPatternBodyType.XWwwFormUrlencoded, httpApi.HttpApiRequestBodyType.XWwwFormUrlencoded);
var isRootFolderId = function isRootFolderId(folderId, rootFolderId) {
  return folderId === 0 || folderId === rootFolderId;
};
var DIRECTORY_TREE_DISPLAY_STYLE = /*#__PURE__*/function (DIRECTORY_TREE_DISPLAY_STYLE) {
  DIRECTORY_TREE_DISPLAY_STYLE["GENERAL_FOLDER"] = "GENERAL_FOLDER";
  DIRECTORY_TREE_DISPLAY_STYLE["MODULE_TITLE"] = "MODULE_TITLE";
  DIRECTORY_TREE_DISPLAY_STYLE["GO_TO_THE_SUBFOLDER"] = "GO_TO_THE_SUBFOLDER";
  return DIRECTORY_TREE_DISPLAY_STYLE;
}({});
var DEFAULT_EXPAND_MODE = /*#__PURE__*/function (DEFAULT_EXPAND_MODE) {
  DEFAULT_EXPAND_MODE["AUTO"] = "AUTO";
  DEFAULT_EXPAND_MODE["EXPAND"] = "EXPAND";
  DEFAULT_EXPAND_MODE["COLLAPSE"] = "COLLAPSE";
  return DEFAULT_EXPAND_MODE;
}({});
var FOLDER_CONTENTS_DISPLAYING_SETTINGS = /*#__PURE__*/function (FOLDER_CONTENTS_DISPLAYING_SETTINGS) {
  FOLDER_CONTENTS_DISPLAYING_SETTINGS["HIDE"] = "HIDE";
  FOLDER_CONTENTS_DISPLAYING_SETTINGS["SUB_LIST"] = "SUB_LIST";
  FOLDER_CONTENTS_DISPLAYING_SETTINGS["CUSTOM_CONTENT"] = "CUSTOM_CONTENT";
  return FOLDER_CONTENTS_DISPLAYING_SETTINGS;
}({});
var ROOT_FOLDER_ID = 0;
exports.DEFAULT_EXPAND_MODE = DEFAULT_EXPAND_MODE;
exports.DIRECTORY_TREE_DISPLAY_STYLE = DIRECTORY_TREE_DISPLAY_STYLE;
exports.FOLDER_CONTENTS_DISPLAYING_SETTINGS = FOLDER_CONTENTS_DISPLAYING_SETTINGS;
exports.IdentityPatternBodyType = IdentityPatternBodyType;
exports.IdentityPatternBodyTypeMap = IdentityPatternBodyTypeMap;
exports.IdentityPatternType = IdentityPatternType;
exports.ROOT_FOLDER_ID = ROOT_FOLDER_ID;
exports.initIdentityPattern = initIdentityPattern;
exports.isRootFolderId = isRootFolderId;
